import gsap from "gsap";

function initHero() {
  const heroImgs = document.querySelector(".hero-content-img") as HTMLElement;

  if (!heroImgs) return;

  const pictures = heroImgs.querySelectorAll("figure");

  if (pictures.length === 0) return;

  pictures.forEach((picture, index) => {
    gsap.set(picture, { opacity: index === 0 ? 1 : 0 });
  });

  const timeline = gsap.timeline({ repeat: -1 });

  pictures.forEach((picture, index) => {
    const nextIndex = (index + 1) % pictures.length;
    const nextPicture = pictures[nextIndex];

    timeline
      .to(picture, {
        opacity: 1,
        duration: 3,
        ease: "none",
      })
      .to(
        picture,
        {
          opacity: 0,
          duration: 0.5,
          ease: "power1.inOut",
        },
        "+=1"
      )
      .to(
        nextPicture,
        {
          opacity: 1,
          duration: 0.5,
          ease: "power1.inOut",
        },
        "<"
      );
  });
}

initHero();
